var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "wrapper",
      attrs: { id: "sideModal" },
      on: { click: _vm.onClose },
    },
    [
      _c("div", { class: { wrapper_body: true, open: _vm.data.open } }, [
        _c(
          "div",
          { staticClass: "body" },
          [
            _c(
              "button",
              {
                staticClass: "btn btn-default closeBtn",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    _vm.data.open = false
                  },
                },
              },
              [_c("i", { staticClass: "icon-fa icon-fa-remove" })]
            ),
            _vm._v(" "),
            _vm.data.type && _vm.data.type === "createDrugTask"
              ? [
                  _c("CreateSiteDrug", {
                    attrs: {
                      taskId: _vm.data.taskId,
                      closeModal: () => _vm.onClose(null, true),
                    },
                  }),
                ]
              : [
                  _c("EditDrugBlock", {
                    attrs: {
                      data: _vm.data,
                      selectedDrug: { id: _vm.data.drugId },
                    },
                  }),
                ],
          ],
          2
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }